import { forwardRef } from 'react';
import { Button, Tooltip } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { ContextMenuGenerationTool } from './components/ContextMenuGenerationTool';
import { useStyles } from './useStyles';

const TOO_LONG_TOOLTIP =
  'Your text is too long to be scored.\nPlease edit your text to 200 words or under.';

export const SelectGenerationTool = forwardRef(
  ({ className, onChange, isTooLong, editing }, ref) => {
    const styles = useStyles();

    const disabled = isTooLong || editing;
    return (
      <div className={cx(styles.root, className)}>
        <ContextMenuGenerationTool
          classes={{ menuPaper: styles.menuPaper }}
          ref={ref}
          onChange={onChange}
          renderButton={(props) => (
            <Tooltip
              title={isTooLong ? TOO_LONG_TOOLTIP : ''}
              onClick={(e) => e.stopPropagation()}
            >
              <span>
                <Button
                  className={styles.button}
                  variant="text"
                  color="primary"
                  size="small"
                  {...props}
                  disabled={disabled}
                  data-testid="scoreTextAsButton"
                >
                  Score text as
                </Button>
              </span>
            </Tooltip>
          )}
          disabled={disabled}
        />
      </div>
    );
  }
);

SelectGenerationTool.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  onChange: PropTypes.func,
  isTooLong: PropTypes.bool,
  editing: PropTypes.bool,
  disabled: PropTypes.bool,
};

SelectGenerationTool.defaultProps = {
  className: null,
  classes: null,
  onChange: null,
  isTooLong: false,
  editing: false,
  disabled: false,
};
